import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import { generateResponsiveStyle } from "../utils/modalStyle";
import CloseIcon from "@mui/icons-material/Close";


type props = {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    publishAll: () => void;
};

const PublishAllWarnModal = ({ open, setOpen, publishAll }: props) => {
    const style = generateResponsiveStyle();
   

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <div className="modal_body logout_body">
                    <CloseIcon className="cross_icn_logout" onClick={() => setOpen(false)} />
                    <Typography
                        id="modal-modal-title"
                        component="h2"
                    >
                        Are you sure you want to Publish all the properties ?
                    </Typography>



                    <div className="form_btn">
                        <Button
                            className="btn btn_primary"
                            onClick={() => {
                                publishAll();
                            }}
                        >
                            Yes
                        </Button>

                        <Button
                            className="btn btn_secondary"
                            onClick={() => setOpen(false)}
                        >
                            No
                        </Button>
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

export default PublishAllWarnModal;
